import clone from 'clone';

import * as types from './constants';

const initialState = {
    stories: [],
    isGettingNewsStories: false,
    newsStoriesError: {}
};

function newsReducer(state = clone(initialState), action) {
    switch(action.type) {
        case types.GET_NEWS_STORIES_START:
            return Object.assign({}, state, {
                isGettingNewsStories: true,
                newsStoriesError: {}
            });
        case types.GET_NEWS_STORIES_SUCCESS:
            return Object.assign({}, state, {
                isGettingNewsStories: false,
                stories: action.data
            });
        case types.GET_NEWS_STORIES_FAILURE:
            return Object.assign({}, state, {
                isGettingNewsStories: false,
                newsStoriesError: action.error
            });
        default:
            return state;
    }
}

export default newsReducer;



// WEBPACK FOOTER //
// ./src/containers/News/store/reducers.js